import React, { useEffect, useState } from "react";
import "./Template_2.css";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import DefaultData from "../../CompanyData/DefaultData";
import Template_2_Header from "./Template_2_Header";
import Template_2_Footer from "./Template_2_Footer";
const Template_2_Destinations = () => {
  const [destinations, setDestinations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const companyId = DefaultData.DEFAULTCOMPANYID;

  // Default images for destinations
  const defaultImages = {
    "ANDAMAN & NICOBAR ISLANDS":
      "https://images.unsplash.com/photo-1561607381-3f0aee9153e1?auto=format&fit=crop&w=800&q=80",
    SHILLONG:
      "https://images.unsplash.com/photo-1579781404557-4d4d1e5d2c1a?auto=format&fit=crop&w=800&q=80",
    LADAKH:
      "https://images.unsplash.com/photo-1593975395647-61a1b7a09b1f?auto=format&fit=crop&w=800&q=80",
    MEGALAYA:
      "https://images.unsplash.com/photo-1593601139938-6b1c6dbf2d5a?auto=format&fit=crop&w=800&q=80",
    MEGHALAYA:
      "https://images.unsplash.com/photo-1593601139938-6b1c6dbf2d5a?auto=format&fit=crop&w=800&q=80",
    MALDIVES:
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=800&q=80",
    DUBAI:
      "https://images.unsplash.com/photo-1568674371763-d2a3b55a1d14?auto=format&fit=crop&w=800&q=80",
    OOTY: "https://images.unsplash.com/photo-1582129878615-71f52f2175ed?auto=format&fit=crop&w=800&q=80",
  };

  // Normalize name and get default image
  const getDefaultImage = (name) => {
    if (!name) return "";
    return defaultImages[name.trim().toUpperCase()] || "";
  };

  useEffect(() => {
    const getDestinations = async () => {
      if (!companyId) return;
      setIsLoading(true);
      try {
        const response = await apiService.getAll(
          `${config.GETALLDESTINATIONS}?companyId=${companyId}`
        );
        console.log("API response:", response);
        setDestinations(response || []);
      } catch (error) {
        console.error("Failed to fetch destinations:", error);
      } finally {
        setIsLoading(false);
      }
    };
    getDestinations();
  }, [companyId]);

  return (
    <div className="Template_2 destinations Template_2 active">
      <Template_2_Header />
      <section className="Template_2 section Template_2 destinations">
        <div className="Template_2 container">
          <div className="Template_2 section-title">
            <h2>Featured Destinations</h2>
            <p>
              Discover the world's most breathtaking locations with our curated
              selection
            </p>
          </div>

          {isLoading ? (
            <p>Loading destinations...</p>
          ) : (
            <div className="Template_2 destinations-grid">
              {destinations.length > 0 ? (
                destinations.map((destination, index) => {
                  const name = destination.destinationName || destination.Name;
                  const packageCount =
                    destination.packageCount || destination.PackageCount || 0;
                  const imageUrl =
                    getDefaultImage(name) ||
                    destination.imageUrl ||
                    destination.Image;

                  return (
                    <div key={index} className="Template_2 destination-card">
                      <div className="Template_2 destination-image">
                        <img src={imageUrl} alt={name} />
                        <div className="Template_2 destination-badge">
                          {packageCount} Packages
                        </div>
                      </div>
                      <div className="Template_2 destination-content">
                        <h3>{name}</h3>
                        <button className="Template_2 destination-btn">
                          Explore Now
                        </button>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p>No destinations available.</p>
              )}
            </div>
          )}
        </div>
      </section>
      <Template_2_Footer />
    </div>
  );
};

export default Template_2_Destinations;
